import { NavItem } from './nav-item/nav-item';

export const adminItems: NavItem[] = [
 
  {
    displayName: 'Dashboard',
    iconName: 'aperture',
    route: '/dashboard',
  },
  {
    displayName: 'Hubs',
    iconName: 'building-store',
    route: 'apps/hubs',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/hubs/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/hubs/list',
      }
    ],
  },

  {
    displayName: 'Products',
    iconName: 'package',
    route: 'apps/products',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/products/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/products/list',
      },
      {
        displayName: 'Categories',
        iconName: 'point',
        route: 'apps/products/categories/list',
      }
    ],
  },

  {
    displayName: 'Retailers',
    iconName: 'user-shield',
    route: 'apps/retailers',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/retailers/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/retailers/list',
      }
    ],
  },

  {
    displayName: 'Orders',
    iconName: 'shopping-cart',
    route: 'apps/orders',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/orders/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/orders/list',
      }
    ],
  },

  {
    displayName: 'Dispatch',
    iconName: 'truck-delivery',
    route: 'apps/dispatch',
    children: [
      {
        displayName: 'Create',
        iconName: 'point',
        route: 'apps/dispatch/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/dispatch/list',
      },
      {
        displayName: 'OTP Settings',
        iconName: 'point',
        route: 'apps/dispatch/otp-config',
      }
    ],
  },

  {
    displayName: 'Stock Requisitions',
    iconName: 'file-check',
    route: 'apps/stock-requisitions',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/stock-requisitions/list',
      },
      {
        displayName: 'Create',
        iconName: 'point',
        route: 'apps/stock-requisitions/add',
      }
    ],
  },

  {
    displayName: 'Inventory',
    iconName: 'stack',
    route: 'apps/inventory',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/inventory/list',
      },
      {
        displayName: 'Transfers',
        iconName: 'point',
        route: 'apps/inventory/transfer/list',
      },
      {
        displayName: 'Create Transfer',
        iconName: 'point',
        route: 'apps/inventory/transfer/add',
      }
    ],
  },

  {
    displayName: 'Vehicles',
    iconName: 'truck',
    route: 'apps/vehicles',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/vehicles/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/vehicles/list',
      }
    ],
  },

  {
    displayName: 'Drivers',
    iconName: 'user',
    route: 'apps/drivers',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/drivers/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/drivers/list',
      },
      {
        displayName: 'Pending Orders',
        iconName: 'point',
        route: 'apps/drivers/pending-orders',
      },
      {
        displayName: 'Pending Order Limit',
        iconName: 'point',
        route: 'apps/drivers/pending-order-limit',
      },
    ],
  },



  {
    displayName: 'Payments',
    iconName: 'moneybag',
    route: 'apps/payments',
    children: [
      {
        displayName: 'Payment List',
        iconName: 'point',
        route: 'apps/payments/payments',
      },
      {
        displayName: 'Payment Methods',
        iconName: 'point',
        route: 'apps/payments/methods',
      }
    ],
  },
  
  {
    displayName: 'Reports',
    iconName: 'chart-infographic',
    route: 'apps/reports',
    children: [
      {
        displayName: 'Targets Settings',
        iconName: 'point',
        route: 'apps/reports/targets-settings',
      },
      {
        displayName: 'Vehicle Operating Cost',
        iconName: 'point',
        route: 'apps/reports/operating-cost-settings',
      },
      {
        displayName: 'Daily Summary',
        iconName: 'point',
        route: 'apps/reports/daily-summary-report',
      },
     
      {
        displayName: 'Products Sold',
        iconName: 'point',
        route: 'apps/reports/products-sold-report',
      },
      {
        displayName: 'Orders Report',
        iconName: 'point',
        route: 'apps/reports/hub-completed-orders-report',
      },
      {
        displayName: 'Sales Report',
        iconName: 'point',
        route: 'apps/reports/income-report',
      },
      {
        displayName: 'Driver Commission',
        iconName: 'point',
        route: 'apps/reports/driver-commission',
      },
      {
        displayName: 'Hub Commission',
        iconName: 'point',
        route: 'apps/reports/hub-commission',
      },
      {
        displayName: 'Driver Retailer Visits',
        iconName: 'point',
        route: 'apps/reports/driver-retailer-visits-report',
      },
      {
        displayName: 'Driver Check-in / Check-out',
        iconName: 'point',
        route: 'apps/reports/driver-checkin-checkout-report',
      },
      {
        displayName: 'Monthly Bales Delivered',
        iconName: 'point',
        route: 'apps/reports/monthly-bales-delivered-report',
      },
      {
        displayName: 'Monthly Bales Deviation',
        iconName: 'point',
        route: 'apps/reports/monthly-bales-deviation-report',
      },
      {
        displayName: 'Driver MTD Performance',
        iconName: 'point',
        route: 'apps/reports/monthly-driver-mtd-report',
      },
      {
        displayName: 'Hub & Spoke MTD Summary',
        iconName: 'point',
        route: 'apps/reports/monthly-hub-mtd-report',
      },
      {
        displayName: 'Hub & Spoke Summary',
        iconName: 'point',
        route: 'apps/reports/monthly-hub-summary-report',
      },
      {
        displayName: 'Monthly Performance',
        iconName: 'point',
        route: 'apps/reports/yearly-monthly-performance-report',
      }
      // {
      //   displayName: 'Company Commission',
      //   iconName: 'point',
      //   route: 'apps/reports/company-commission',
      // },
      // {
      //   displayName: 'Payment Methods',
      //   iconName: 'point',
      //   route: 'apps/reports/payment-methods-report',
      // },
      // {
      //   displayName: 'Credit Payments Aging',
      //   iconName: 'point',
      //   route: 'apps/reports/credit-payments-aging-report',
      // },
      // {
      //   displayName: 'Credit Aging Buckets',
      //   iconName: 'point',
      //   route: 'apps/reports/credit-aging-buckets',
      // },
      
    ],
  },




  
  


  {
    navCap: 'Settings',
  },

  {
    displayName: 'App Version',
    iconName: 'device-mobile',
    route: 'apps/settings/app-version',
  },

  {
    displayName: 'Offers',
    iconName: 'gift',
    route: 'apps/offers',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/offers/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/offers/list',
      },
      {
        displayName: 'Claims',
        iconName: 'point',
        route: 'apps/offers/claims',
      }
    ],
  },
  
  {
    displayName: 'Users',
    iconName: 'users',
    route: 'apps/users',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/users/list',
      },
      {
        displayName: 'Send Email',
        iconName: 'point',
        route: 'apps/users/send-email',
      },
    ],
  }
,
  
  // {
  //   displayName: 'Companies',
  //   iconName: 'home-2',
  //   route: 'apps/companies',
  //   children: [
  //     {
  //       displayName: 'Add',
  //       iconName: 'point',
  //       route: 'apps/companies/add',
  //     },
  //     {
  //       displayName: 'List',
  //       iconName: 'point',
  //       route: 'apps/companies/list',
  //     }
  //   ],
  // },

  {
    displayName: 'Roles',
    iconName: 'lock-access',
    route: 'apps/roles',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/roles/add',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/roles/list',
      }
    ],
  },

  // {
  //   displayName: 'User Groups',
  //   iconName: 'users',
  //   route: 'apps/groups',
  //   children: [
  //     {
  //       displayName: 'Add Group',
  //       iconName: 'point',
  //       route: 'apps/groups/add',
  //     },
  //     {
  //       displayName: 'Groups List',
  //       iconName: 'point',
  //       route: 'apps/groups/list',
  //     }
  //   ],
  // },
  // {
  //   displayName: 'Modules',
  //   iconName: 'files',
  //   route: '/apps/pages/list',
  // },

  {
    displayName: 'Account Setting',
    iconName: 'user-circle',
    route: '/apps/users/account',
  },

 
];
